import { cn } from "@/utils/classnames";
import { recurringInvoiceStatusMap } from "@/constants/invoice";

interface RecurringStatusBadgeProps {
  status: string;
}

export function RecurringStatusBadge({ status }: RecurringStatusBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset",
        {
          "text-green-700 ring-green-600/20 bg-green-50": status === "active",
          "text-yellow-700 ring-yellow-600/20 bg-yellow-50":
            status === "paused",
          "text-gray-700 ring-gray-600/20 bg-gray-50": status === "cancelled",
        }
      )}
    >
      <span className="whitespace-nowrap">
        {recurringInvoiceStatusMap[status]?.label || status}
      </span>
    </span>
  );
}
